import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';

import { buscarMetodosConfiguracion } from '../../../actions/configuracion';
import { editarBreadcrumb } from '../../../actions/breadcrumb';

import NuevoMetodo from './NuevoMetodo';
import EditarMetodo from './EditarMetodo';
import EliminarMetodo from './EliminarMetodo';

const tiposMetodo = [
    { value: 1, label: 'Cobrar' },
    { value: 2, label: 'Pagar' },
    { value: 3, label: 'Ambos' }
];

const Metodos = () => {

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.configuracion.metodos);
    const { usuario } = useSelector(state => state.auth);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);
    const [metodoEliminar, setMetodoEliminar] = useState(null);

    useEffect(() => {
        dispatch(buscarMetodosConfiguracion());
        dispatch(editarBreadcrumb([
            { nombre: 'Configuración', path: '/configuracion/metodos', activo: false },
            { nombre: 'Métodos', path: '/configuracion/metodos', activo: true }
        ]));
    }, []);

    const handleEditar = (metodo) => {
        setMetodoSeleccionado(metodo);
    };

    const handleEliminar = (metodo) => {
        setMetodoEliminar(metodo);
    };

    const handleCerrarEditar = () => {
        setMetodoSeleccionado(null);
    };

    const handleCerrarEliminar = () => {
        setMetodoEliminar(null);
    };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true,
            selector: row => tiposMetodo.find(t => t.value === row.tipo)?.label || '-'
        },
        {
            name: 'Descripción',
            sortable: true,
            selector: row => row.descripcion || '-',
            grow: 3
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.configuracion?.metodos?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => handleEditar(row)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.configuracion?.metodos?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => handleEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Métodos</h4>
                {usuario?.permisos?.configuracion?.metodos?.agregar && (
                    <button className="btn btn-primary" onClick={() => setNuevoModal(true)}>
                        <i className="fas fa-plus me-1"></i> Nuevo método
                    </button>
                )}
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay métodos registrados"
                />
            </div>

            <NuevoMetodo
                show={nuevoModal}
                handleCerrar={() => setNuevoModal(false)}
            />

            <EditarMetodo
                metodo={metodoSeleccionado}
                handleCerrar={handleCerrarEditar}
            />

            <EliminarMetodo
                metodo={metodoEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Metodos;
